<ion-header>
  <ion-toolbar>
     <ion-grid>
       <ion-row *ngIf="showPenmateName; else legacyLayout">
         <ion-col col size="3">
           <span>
             <a class="go-back" (click)="onGoBack()" *ngIf="back && !hideBack && !showDoneWriting">
               <ion-icon name="arrow-back"></ion-icon>
               Back
             </a>
           </span>
         </ion-col>
         <ion-col size="6" class="penmate-title-col">
           <div class="penmate-title ph-no-capture" [attr.title]="penmateDisplayName">{{ penmateDisplayName }}</div>
         </ion-col>
         <ion-col size="3">
           <div class="help-button" (click)="onShowHelpWidget()" *ngIf="showHelp">
             <ion-icon name="help-buoy"></ion-icon>
             <span class="text">HELP</span>
           </div>
         </ion-col>
       </ion-row>

       <ng-template #legacyLayout>
         <ion-row>
           <ion-col col [size]="back ? '5' : null" *ngIf="back">
             <span>
               <a class="go-back" (click)="onGoBack()" *ngIf="!hideBack && !showDoneWriting">
                 <ion-icon name="arrow-back"></ion-icon>
                 Back
               </a>
             </span>
           </ion-col>
           <ion-col *ngIf="!back"></ion-col>
           <ion-col>
             <div class="help-button" (click)="onShowHelpWidget()" *ngIf="showHelp">
               <ion-icon name="help-buoy"></ion-icon>
               <span class="text">HELP</span>
             </div>
           </ion-col>
         </ion-row>
       </ng-template>
     </ion-grid>
     
     <!-- Save status indicator -->
     <div class="save-status" *ngIf="saveStatus && saveStatus.status !== 'idle'">
       <ion-spinner name="dots" *ngIf="saveStatus.status === 'saving'"></ion-spinner>
       <ion-icon name="checkmark-circle" *ngIf="saveStatus.status === 'saved'" 
                 class="saved-icon"></ion-icon>
       <ion-icon name="alert-circle" *ngIf="saveStatus.status === 'error'" 
                 class="error-icon" 
                 [attr.title]="'Save failed. Will retry automatically.'"></ion-icon>
     </div>
   </ion-toolbar>
   <div class="penmate-avatar" *ngIf="!showPenmateName">
     <div class="icon-circle">
       <div class="inner-circle">
         <span *ngIf="penmate.initials && !penmate.image" class="initials">{{penmate.initials}}</span>
         <img *ngIf="penmate.image" [src]="penmate.image" />
         <ion-icon *ngIf="!penmate.initials && !penmate.image" name="ios-person" size="large"></ion-icon>
 
       </div>
     </div>
   </div>
 </ion-header>
 
